import React from "react"
import { Card, Space, Row, Col, Typography } from "antd"
import { BankFilled } from "@ant-design/icons"
import { gray } from "@ant-design/colors"
import capitalize from "lodash.capitalize"

import { W0, W1 } from "@components/constants"
import FormattedValue from "@components/FormattedValue"

import SourceStatusTag from "./SourceStatusTag"

const { Meta } = Card
const { Text } = Typography


const CustomerSource = ({ source }) => {
  const {
    name,
    createdAt,
    accountType,
    fundingSourceUrl
  } = source

  const getAccountType = () => capitalize(accountType)

  const getDwollaSourceId = () => {
    const [ id ] = fundingSourceUrl.split('/').reverse()

    return id
  }

  const avatar = <BankFilled style={{ fontSize: 42, color: gray.primary }} />

  const description = (
    <Row>
      <Col flex="auto">
        <Typography.Title level={5} style={{ margin: 0 }}>
          {name}
        </Typography.Title>
        {getAccountType()}
      </Col>
      <Col>
        <SourceStatusTag source={source} />
      </Col>
    </Row>
  )

  return (
    <Card size="small" style={{ padding: W0 }}>
      <Meta
        avatar={avatar}
        description={description}
      />

      <Space direction="vertical" style={{ marginTop: W1 }} size={W0 / 2}>
        <Text type="secondary">
          Added: <FormattedValue value={createdAt} />
        </Text>
        <Text type="secondary">
          Dwolla Source ID: {getDwollaSourceId()}
        </Text>
      </Space>
    </Card>
  )
}

export default CustomerSource;
